
import { styled } from "styled-components";

const TooltipStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.theme.contentBg};
  align-items: start;

  display: flex;
  flex-flow: column;
  border-radius: 12px;
  backdrop-filter: blur(16px);
  overflow: hidden;

  width: 360px;

  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);

  font-family: "Red Hat Display";
  text-align: start;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;

const TooltipText = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
  align-items: center;
  padding: 16px;
  width: 100%;
  color: ${({ theme }) => theme.colors.text.headings}
`

export {
  TooltipStyled,
  TooltipText,
};
